import { format } from "fecha";
import type { CellComponent } from "tabulator-tables";

import type { EqLocationTypeId, InstallationSituationId, ObsNetworkId } from "../enums";
import { eqLocationTypeIdToString, installationSituationIdToString, obsNetworkIdToString } from "../enums";

/**
 * 文字列をフォーマットする。
 *
 * @param value 値
 * @returns フォーマット後文字列
 */
export const stringFormatter = (value: string | null | undefined) => {
    return value ?? "-";
};

/**
 * 文字列のセルの値をフォーマットする。
 *
 * @param cell セル
 * @returns フォーマット後の値
 */
export const stringCellFormatter = (cell: CellComponent) => {
    const value = cell.getValue() as string | undefined;
    return stringFormatter(value);
};

/**
 * 地震発生時刻の値をフォーマットする。
 *
 * @param cell セル
 * @returns フォーマット後の値
 */
export const originTimeFormatter = (cell: CellComponent) => {
    const value = cell.getValue() as string | undefined;
    return (value) ? format(new Date(value), "YYYY-MM-DD HH:mm:ss") : "-";
};

/**
 * 運用日の値をフォーマットする。
 *
 * @param cell セル
 * @returns フォーマット後の値
 */
export const workingTimeFormatter = (cell: CellComponent) => {
    const value = cell.getValue() as string | undefined;
    return (value) ? format(new Date(value), "YYYY-MM-DD") : "-";
};

/**
 * 観測網の値をフォーマットする。
 *
 * @param cell セル
 * @returns フォーマット後の値
 */
export const obsNetworkIdFormatter = (cell: CellComponent) => {
    return obsNetworkIdToString(cell.getValue() as ObsNetworkId);
};

/**
 * 設置場所の値をフォーマットする。
 *
 * @param cell セル
 * @returns フォーマット後の値
 */
export const installationSituationIdFormatter = (cell: CellComponent) => {
    return installationSituationIdToString(cell.getValue() as InstallationSituationId);
};

/**
 * 地震発生位置種別の値をフォーマットする。
 *
 * @param cell セル
 * @returns フォーマット後の値
 */
export const eqLocationTypeIdFormatter = (cell: CellComponent) => {
    return eqLocationTypeIdToString(cell.getValue() as EqLocationTypeId);
};
